const features = [
  {
    icon: "ri-database-2-line",
    title: "Smart Data Organization",
    description: "Manage information with structured spreadsheet systems designed for efficiency and clarity.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Professional Templates",
    description: "Use ready-made spreadsheet formats optimized for business, inventory, and daily workflows.",
  },
  {
    icon: "ri-rocket-line",
    title: "Better Productivity",
    description: "Reduce manual work and improve efficiency with automated calculations and smart features.",
  },
  {
    icon: "ri-store-2-line",
    title: "Business Management",
    description: "Track inventory, products and operations seamlessly with integrated management tools.",
  },
];

export default function FeatureCards() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Why Choose Vigorbuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Discover what makes Vigorbuy Spreadsheet the preferred choice for data organization and business management.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 md:p-8 bg-background-50 border border-background-200/60 rounded-lg hover:border-accent-200/60 transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}